import { ItemDetailsPanel, ItemDetailsPanelProps } from '@/views';
import {
  SubOptionState,
  useGetItemMenuItemsQuery,
  useGetPersonalizationAvailableSubOptionsQuery,
} from '@/redux';
import { array } from '@/utils';

interface ItemDetailsLocalProps extends ItemDetailsPanelProps {
  homeId: string;
  projectId: string;
}

export function ItemListDetailsLocal(props: ItemDetailsLocalProps) {
  const {
    id,
    selectableSuboption,
    includeUnlistedSuboptions,
    homeId,
    projectId,
  } = props;
  const { data = array.empty<SubOptionState>() } =
    useGetPersonalizationAvailableSubOptionsQuery({
      homeId,
      projectId,
      itemId: props.id,
      includeUnlisted: includeUnlistedSuboptions,
    });
  const { data: itemMenuItems } = useGetItemMenuItemsQuery({
    projectId,
    homeId,
  });
  const itemMenuItem = itemMenuItems?.find((x) => x.id === id);

  return (
    <ItemDetailsPanel
      id={id}
      selectableSuboption={selectableSuboption}
      includeUnlistedSuboptions={includeUnlistedSuboptions}
      subOptions={data}
      readonly
      itemMenuItemType={itemMenuItem?.type}
    />
  );
}
